<template>
    <div class="uk-padding uk-background-muted">
        <h1 class="uk-heading-line uk-text-center">Our Services</h1>
        <div class="uk-container uk-container">
            <div uk-grid >
                <div class="uk-width-auto@s nav_move" style="" >
                    <ul class="uk-tab-left" uk-tab="connect: #component-tab-left; animation: uk-animation-fade">
                      <li>

                          <button class="uk-button uk-button-default uk-text-capitalize uk-width-1-1@s">
                            <span style="color: rgb(197,179,88) !important;" uk-icon="icon: lifesaver; ratio: 1.3">  </span>
                            Accounting Services
                          </button>
                        </li>
                      <li>
                            <button class="uk-button uk-button-default uk-text-capitalize uk-width-1-1@s">
                                <span style="color: rgb(197,179,88) !important;" uk-icon="icon: users; ratio: 1.3">  </span>
                                Advisory Services
                            </button>
                        </li>
                      <li>

                            <button class="uk-button uk-button-default uk-text-capitalize uk-width-1-1@s">
                                <span style="color: rgb(197,179,88) !important;" uk-icon="icon: info; ratio: 1.3">  </span>
                                Financial Reporting
                            </button>
                        </li>
                      <li>

                        <button class="uk-button uk-button-default uk-text-capitalize uk-width-1-1@s">
                            <span style="color: rgb(197,179,88) !important;" uk-icon="icon: settings; ratio: 1.3">  </span>
                            Compliance Monitoring
                        </button>
                        </li>
                      <li>

                        <button class="uk-button uk-button-default uk-text-capitalize uk-width-1-1@s">
                            <span style="color: rgb(197,179,88) !important;" uk-icon="icon: world; ratio: 1.3">  </span>
                            Board Governance <span class="uk-visible@s">& Support</span>
                        </button>
                        </li>
                    </ul>
                </div>
                <div class="uk-width-expand@s">
                    <ul id="component-tab-left" class="uk-switcher">
                      <li>
                        <div class="uk-flex-wrap-middle" uk-grid>
                          <div class="uk-width-1-3@s uk-visible@l">
                            <img src="@/assets/Shirt_sign.jpg"
                                 style="border-radius: 5px; margin-left: -60px; margin-top: 15px" alt="">
                          </div>
                          <div class="uk-width-2-3@s ">
                            <div class="uk-padding" style="margin-left: -45px">
                              <h4 class="uk-text-uppercase">Accounting Services</h4>
                              <p class="uk-text-small">
                                FINCOR offers expert
                                accounting and advisory services to help management
                                and businesses become more successful.
                                Each client receives a customized service based on their needs, we can either support the staff you have
                                now, or take over the full finance function.
                              </p>
                              <ul class="uk-list uk-list-bullet ">Our Accounting Services range from
                                <li style="margin-top: 0" class="uk-text-small">
                                  <a href="/accounting-services#complete-financial-management">Complete Financial Management</a>
                                </li>
                                <li style="margin-top: 0" class="uk-text-small">
                                  <a href="/accounting-services#preparation-of-annual-accounts">Preparation of Annual Accounts</a>
                                </li>
                                <li style="margin-top: 0" class="uk-text-small">
                                  <a href="/accounting-services#budget-preparations">Budget Preparations</a>
                                </li>
                                <li style="margin-top: 0" class="uk-text-small">
                                  <a href="/accounting-services#compliance-monitoring">Complaince Monitoring</a>
                                </li>
                                <li style="margin-top: 0" class="uk-text-small">
                                  <a href="/accounting-services#cfo-services">CFO Services</a>
                                </li>
                              </ul>


                            </div>
                            <div style="margin-top: -45px">
                              <router-link to="/accounting-services" class="uk-button  uk-button-small uk-margin-remove-left">Learn More ..</router-link>
                            </div>
                          </div>
                        </div>
<!--                        <div class="uk-child-width-1-1@m" uk-grid>
                          <div>
                            <ul class="uk-list uk-list-divider">
                              <li class="makeGold">Complete Financial Management
                                <br>
                                <span class="makeSilver uk-text-small">
                                  We will work with you as a trusted partner to ensure that the
                                  finances of your business are well managed. We have years of experience managing the full accounting
                                  cycle from data entry to completion of annual financial statements at a cost that is a fraction of full-time
                                  staff.
                                            </span>
                              </li>
                              <li class="makeGold">Preparation of Annual Accounts
                                <br>
                                <span class="makeSilver uk-text-small">
                                  Looking for professional financial statements for your bank or to give
                                  your partners, shareholders, or management team a clear understanding of how your business is
                                  performing? Trust FINCOR to deliver professional accurate financial statements including management
                                  discussion and analysis, supporting notes, charts, and breakdowns.
                                </span>
                              </li>
                              <li class="makeGold">Budget Preparations
                                <br>
                                <span class="makeSilver uk-text-small">
                                  Are you setting the financial targets for your organization for the upcoming
                                  period? Are you looking to work with professionals who can review your proposed spend, show you the
                                  impact of your business assumptions and identify opportunities to save costs? FINCOR can help, we have
                                  years of experience helping organizations develop multi-million-dollar budgets, operate more efficiently
                                  and present budget information to stakeholders ranging from banks to Parliament.
                                </span>
                              </li>
                              <li class="makeGold">CFO Services
                                <br>
                                <span class="makeSilver uk-text-small">
                                  Do you have lower-level bookkeeping staff that do the day to day postings and functions
                                  but looking for an experienced qualified accountant to review their work, provide reporting and advice?
                                  We offer decades of experience managing the finances of businesses of all levels.
                                </span>
                              </li>

                            </ul>
                          </div>

                        </div>-->
                      </li>
                      <li>
                        <div class="uk-flex-wrap-middle" uk-grid>
                          <div class="uk-width-1-3@s uk-visible@l">
                            <img src="@/assets/cottonbro.jpg"
                                 style="border-radius: 5px; margin-left: -60px; margin-top: 15px" alt="">
                          </div>
                          <div class="uk-width-2-3@s ">
                            <div class="uk-padding" style="margin-left: -45px; margin-top: 0">
                              <h4 class="uk-text-uppercase">Advisory Services</h4>
                              <p class="uk-text-small">
                                We provide consulting services to a range of public and private entities in key strategic areas including:
                              </p>
                              <ul class="uk-list uk-list-bullet uk-text-small">
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#public-sector-board-support">Public Sector Board Support</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#management-support">Management Support</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#compliance-monitoring">Compliance Monitoring</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#business-case-preparation">Business Case Preparation</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#procurement-management">Procurement Management</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#training">Training</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/financial-advisory-services#notary-services">Notary Public Services</a>
                                </li>

                              </ul>
                             <div>
                               <router-link to="/financial-advisory-services" class="uk-button  uk-button-small">Learn More ..</router-link>
                             </div>
                            </div>

                          </div>
                        </div>
<!--                            <div class="uk-child-width-1-2@m" uk-grid>
                                <div>
                                    <ul class="uk-list uk-list-divider">
                                        <li class="makeGold">
                                          Public Sector Board support
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                With over a decade of experience on Public Sector Boards, we can help
                                                new or existing Boards navigate the requirements of the Public Authorities Act, understand
                                                procurement, understand budgeting, and develop a performance management framework for the CEO
                                                or Managing Director.
                                            </span>
                                        </li>
                                        <li class="makeGold">Management Support
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              Whether you are a private business owner looking to take your business to the
                                              next level; preparing to make a pitch to the bank for financing; or struggling with the rigors of keeping
                                              up with trade and business licensing requirements, monthly payments, reporting requirements etc.
                                              FINCOR can help.
                                            </span>
                                        </li>
                                        <li class="makeGold">Business Case Preparation
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              We have supported entities in preparing Outline Business Cases based on
                                              the UK Treasury’s Five-case model for over a decade.                                            </span>
                                        </li>
                                        <li class="makeGold">Procurement Management
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              Do you have a major project and need to prepare a Request for Proposal?
                                              FINCOR can help you navigate the complex requirements of the Procurement Act and public sector
                                              procurement policies and procedures.                                            </span>
                                        </li>
                                        <li class="makeGold">Procurement Management
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              Do you have a major project and need to prepare a Request for Proposal?
                                              FINCOR can help you navigate the complex requirements of the Procurement Act and public sector
                                              procurement policies and procedures.                                            </span>
                                        </li>

                                    </ul>
                                </div>
                                <div>
                                    <ul class="uk-list uk-list-divider">
                                        <li class="makeGold">
                                            <span >
                                                Training
                                            </span>
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              Looking for an experienced team to deliver a workshop on budgeting, financial management,
                                              procurement, business case preparation or other public sector financial topics? We have successfully
                                              developed and delivered multiple training workshops for Boards, accounting teams, middle managers
                                              and staff looking to move up within their Department or Ministry.
                                            </span>
                                        </li>
                                        <li class="makeGold">Notary Public Services
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We offer Notary Public services for official documents required for Banks,
                                                Government and regulatory agencies. Our full-time clients also receive this as a complementary service.
                                                Please give us a call <router-link to="/contact-us">here</router-link> for your Notary Public needs.
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>-->
                        </li>
                      <li>
                        <div class="uk-flex-wrap-middle " uk-grid>
                          <div class="uk-width-1-3@s uk-visible@l">
                            <img src="@/assets/mark_spike.jpg"
                                 style="border-radius: 5px; margin-left: -60px; margin-top: 15px" alt="">
                          </div>
                          <div class="uk-width-2-3@s ">
                            <div style="margin-left: -45px;" class="uk-padding ">
                              <h4 class="uk-text-uppercase">Financial Reporting</h4>
                              <p class="uk-text-small">
                                Managers cannot manage what they don’t measure,
                                Financial Reporting provides insights on the health of
                                operations, sources of income, use, areas of growth,
                                areas of decline as well as risks and opportunities.
                              </p>
<!--                              <p class="uk-text-small">
                                At Fincor we are always ready to help you to develop your reports and/or analyze through the numbers
                                with you to help you build for the future.
                              </p>-->
                              <ul class="uk-list uk-list-bullet uk-text-small">
                                Let us help you monitor and manage your business through:
                                <li class="uk-text-small" style="margin-top: 0">
                                  <a href="/financial-reporting-services#preparation-of-financial-statements">Preparation of Financial Statements</a>
                                </li>
                                <li class="uk-text-small" style="margin-top: 0">
                                  <a href="/financial-reporting-services#annual-reports">Annual Reports</a>
                                </li>
                                <li class="uk-text-small" style="margin-top: 0">
                                  <a href="/financial-reporting-services#strata-and-non-profits">Financial Reporting for Strata Corporations and Non-Profits</a>
                                </li>
                              </ul>

                            </div>
                            <div style="margin-top: -45px">
                              <router-link to="/financial-reporting-services" class="uk-button  uk-button-small uk-margin-remove-left">Learn More ..</router-link>
                            </div>
                          </div>
                        </div>
<!--                            <div class="uk-child-width-1-1@m" uk-grid>
                                <div>
                                    <ul class="uk-list uk-list-divider">
                                        <li class="makeGold">Financial statements;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              When was the last time someone sat with you and went through
                                              the financial statements for your business? Trust FINCOR to provide professional, accurate and complete
                                              financial statements in accordance with international standards for your Bank, the Auditors, or your
                                              Board.
                                            </span>
                                        </li>
                                        <li class="makeGold">Annual Reports;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              We prepare professional annual reports for several agencies each year. We help
                                              management to highlight their organization’s achievements, formulate looking ahead statements and
                                              provide accountability to key stakeholders.
                                            </span>
                                        </li>
                                        <li class="makeGold">Financial Reporting for Strata Corporations and Non-Profits
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                              Are you part of an organization which
                                              handles significant cash resources but you’re not really sure how that money is being spent? FINCOR can
                                              help by providing independent third-party reporting for your Home Owners Association (Strata) Church,
                                              non-profit or other charitable organizations.
                                            </span>
                                        </li>
&lt;!&ndash;                                        <li class="makeGold">Personal Financials for Immigration.
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We provide high net-worth clients with a complete set of personal financial statements to support
                                                applications to the Immigration Department for Permanent Residency applications.
                                            </span>
                                        </li>&ndash;&gt;
                                    </ul>
                                </div>

                            </div>-->
                        </li>
                      <li>
                        <div class="uk-flex-wrap-middle " uk-grid>
                          <div class="uk-width-1-3@s uk-visible@l">
                            <img src="@/assets/compliance.jpg"
                                 style="border-radius: 5px; margin-left: -60px; margin-top: 15px" alt="">
                          </div>
                          <div class="uk-width-2-3@s ">
                            <div style="margin-left: -45px; " class="uk-padding uk-margin-small-top">
                              <h4 class="uk-text-uppercase">Compliance Monitoring</h4>
                              <p class="uk-text-small">
                                You’ve implemented rules, policies, and procedures, but
                                how do you know they are being practiced? FINCOR can
                                help through:
                              </p>

                              <!--                              <p class="uk-text-small">
                                                              At Fincor we are always ready to help you to develop your reports and/or analyze through the numbers
                                                              with you to help you build for the future.
                                                            </p>-->
                              <ul class="uk-list uk-list-bullet uk-text-small">

                                <li style="margin-top: 0">
                                  <a href="/compliance-monitoring-services#output-delivery-compliance" >Output Delivery Compliance</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/compliance-monitoring-services#FeeRemittance">Fee Remittance Compliance</a>
                                </li>
                                <li style="margin-top: 0">
                                  <a href="/compliance-monitoring-services#ComplianceInspections">Compliance Inspections</a>
                                </li>
                              </ul>
                            </div>
                            <div style="margin-top: -45px">
                              <router-link to="/compliance-monitoring-services" class="uk-button  uk-button-small uk-margin-remove-left">Learn More ..</router-link>
                            </div>
                          </div>
                        </div>
<!--                            <div class="uk-child-width-1-1@m" uk-grid>
                                <div>
                                    <ul class="uk-list uk-list-divider">
                                        <li class="makeGold">Preparation of Financial statements;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We can provide professional, accurate and complete financial statements in accordance with international standards for your Bank, the Auditors or your Board.
                                            </span>
                                        </li>
                                        <li class="makeGold">Annual Reports;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We’ll provide a professionally prepared report which tells the story about your organization’s financial performance from the strategic, operational and financial perspectives.
                                            </span>
                                        </li>
                                        <li class="makeGold">Preparation of Bank Compliance Reporting;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We help our clients meet the reporting requirements pertaining to their business loans, mortgages and other instruments, as required by financial institutions.
                                            </span>
                                        </li>
                                        <li class="makeGold">Personal Financials for Immigration.
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We provide high net-worth clients with a complete set of personal financial statements to support
                                                applications to the Immigration Department for Permanent Residency applications.
                                            </span>
                                        </li>
                                    </ul>
                                </div>

                            </div>-->
                        </li>
                      <li>
                        <div class="uk-flex-wrap-middle " uk-grid>
                          <div class="uk-width-1-3@s uk-visible@l">
                            <img src="@/assets/governance.jpg"
                                 style="border-radius: 5px; margin-left: -60px; margin-top: 15px" alt="">
                          </div>
                          <div class="uk-width-2-3@s ">
                            <div style="margin-left: -45px;" class="uk-padding ">
                              <h4 class="uk-text-uppercase">Board Governance & Support</h4>
                              <p class="uk-text-small">
                                FINCOR offers advice and support to new and existing
                                Boards on the intricacies of Public Sector Governance.
                                We ensure you effectively use the tools at your disposal
                                to maintain accountability while staying compliant with
                                relevant legislation including the Public Authorities Act.
                                Our services include:
                              </p>


                              <!--                              <p class="uk-text-small">
                                                              At Fincor we are always ready to help you to develop your reports and/or analyze through the numbers
                                                              with you to help you build for the future.
                                                            </p>-->
                              <ul class="uk-list uk-list-bullet uk-text-small">
<!--                                We provide different services to help ensure your company has that secret weapon to propel you
                                above the competition.-->
                                <li style="margin-top: 0"><a href="/board-governance-and-support#strategic-planning">Strategic Planning</a></li>
                                <li style="margin-top: 0"><a href="/board-governance-and-support#ceo-performance-assessment">CEO Performance Assessment</a></li>
                                <li style="margin-top: 0"><a href="/board-governance-and-support#procurement-oversight">Procurement Oversight</a></li>
                                <li style="margin-top: 0"><a href="/board-governance-and-support#business-case-analysis">Business Case Analysis & Support</a></li>

                                <li style="margin-top: 0">
                                  <a href="/board-governance-and-support#attend-board-and-committee-meetings">Attend board and committee meetings in a minute-taking and advisory capacity</a>
                                </li>
                              </ul>
                            </div>
                            <div style="margin-top: -45px">
                              <router-link to="/board-governance-and-support" class="uk-button  uk-button-small uk-margin-remove-left">Learn More ..</router-link>
                            </div>
                          </div>
                        </div>
<!--                            <div class="uk-child-width-1-1@m" uk-grid>
                                <div>
                                    <ul class="uk-list uk-list-divider">
                                        <li class="makeGold">Preparation of Financial statements;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We can provide professional, accurate and complete financial statements in accordance with international standards for your Bank, the Auditors or your Board.
                                            </span>
                                        </li>
                                        <li class="makeGold">Annual Reports;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We’ll provide a professionally prepared report which tells the story about your organization’s financial performance from the strategic, operational and financial perspectives.
                                            </span>
                                        </li>
                                        <li class="makeGold">Preparation of Bank Compliance Reporting;
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We help our clients meet the reporting requirements pertaining to their business loans, mortgages and other instruments, as required by financial institutions.
                                            </span>
                                        </li>
                                        <li class="makeGold">Personal Financials for Immigration.
                                            <br>
                                            <span class="makeSilver uk-text-small">
                                                We provide high net-worth clients with a complete set of personal financial statements to support
                                                applications to the Immigration Department for Permanent Residency applications.
                                            </span>
                                        </li>
                                    </ul>
                                </div>

                            </div>-->
                        </li>

                    </ul>
                </div>
            </div>

            <div uk-grid>
                <div class="uk-width-1-3@m">
                    <ul class="uk-list uk-list-divider">

                    </ul>
                </div>
                <div class="uk-width-2-3@m"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "whatwedo"
    }
</script>

<style scoped>

    /* Custom, iPhone Retina */
    @media only screen and (min-width : 320px) {
        .uk-tab-left li {
            padding: 10px;
            /*margin-top: 30px;
            margin-bottom: 30px;*/
        }
        .uk-tab-left li button{
            border: none !important;
            text-align: left;
            font-size: 16px;
            color: black;

        }
        .uk-tab-left li button:hover{
            border: none !important;
            text-align: left;
            color: silver
        }
        .uk-tab-left .uk-active{
            color: rgb(197,179,88);
            background: rgba(245,245,245 ,1);
        }
        .makeSilver{
            color: silver;
        }
        .makeGold{
            color: rgb(197,179,88) ;
        }
        .nav_move{
          background-color: white; padding: 15px;
        }
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width : 480px) {

    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) {

    }

    /* Medium Devices, Desktops */
    @media only screen and (min-width : 992px) {

    }

    /* Large Devices, Wide Screens */
    @media only screen and (min-width : 1200px) {
        .uk-tab-left li {
            padding: 10px;
            /*margin-top: 30px;
            margin-bottom: 30px;*/
        }
        .uk-tab-left li button{
            border: none !important;
            text-align: left;
            font-size: 18px;
            color: black;

        }
        .uk-tab-left li button:hover{
            border: none !important;
            text-align: left;
            color: silver
        }
        .uk-tab-left .uk-active{
            color: rgb(197,179,88);
            background: rgba(245,245,245 ,1);
        }
        .makeSilver{
            color: silver;
        }
        .makeGold{
            color: rgb(197,179,88) ;
        }
      .nav_move{
        background-color: white; padding: 30px; padding-right: 120px
      }
    }
</style>